import { otmsHttp } from '@/utils/http/index.js'

/**
 * 规则获取
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/24919
 */
export function ruleGroupMap(data) {
  return otmsHttp.request({
    url: '/cms_plus/rule_resolve/group/map',
    method: 'post',
    data,
  });
}

/**
 * 企业获取敏感字段
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/33701
 */
export function ruleCropSensitive(data) {
  return otmsHttp.request({
    url: '/cms_plus/rule_resolve/crop/sensitive_fields',
    method: 'post',
    data,
  });
}


/**
 * 查询货主(客户)列表
 */
 export function customerList(data, params) {
  return otmsHttp.post('/crm_plus/customer/page', data, { params });
}

// // 货主订单配置查询
// export function getOrderRule(data, params) {
//   return otmsHttp.post('/cms_plus/process_rule/customer/detail/list', data, { params });
// }
/**
 * 根据仓查站点
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/9762
 */
export function getStationByWarehouse(data) {
  return otmsHttp.post('/base_plus/unify_station/list', data);
}

/**
 * 获取参数配置(新)
 */
 export function configCenterPage(data, params) {
  return otmsHttp.post('/bfs-config/config_center/page', data, { params });
}